import React from 'react';
import { PageLayout } from '../../components/PageLayout';
import { HeaderBanner } from './HeaderBanner';
import { IntroContent } from './IntroContent';
import { VenueFeatures } from './VenueFeatures';
import { RentalRates } from './RentalRates';
import { ContactSection } from './ContactSection';
import { QuickLinks } from './QuickLinks';
export function ClubhouseRentalPage() {
  return <PageLayout data-id="element-527">
      <HeaderBanner data-id="element-528" />
      <IntroContent data-id="element-529" />
      <VenueFeatures data-id="element-530" />
      <RentalRates data-id="element-531" />
      <ContactSection data-id="element-532" />
      <QuickLinks data-id="element-533" />
    </PageLayout>;
}